import React from 'react';

function TrunkOptionCards({ name, options, selectedValue, onSelect }) {
  return (
    <div className="trunk-option-cards">
      {options.map(({ id, value, title, description }) => {
        const isSelected = selectedValue === value;
        return (
          <label key={id} htmlFor={id} className={`trunk-option-card${isSelected ? ' is-selected' : ''}`}>
            <input
              type="radio"
              id={id}
              name={name}
              value={value}
              checked={isSelected}
              className="trunk-option-radio"
              onChange={(event) => onSelect(event.target)}
            />
            <span className="trunk-option-title">{title}</span>
            <span className="trunk-option-description">{description}</span>
          </label>
        );
      })}
    </div>
  );
}

export default TrunkOptionCards;
